import { API } from "aws-amplify";

export const lazyFetch = async (tableName = "", listOfKeys = []) => {
  return await API.get("lazyFetching", "/lazyFetching", {
    queryStringParameters: { tableName, listOfKeys },
  });
};
